<mat-card
  class="container {{ class }}"
  [ngClass]="{
    'bundle-selected': selected,
    'addon-selected': addOnSelected,
    'addon-included': includedAddOn,
    'mt-lg': isRoadtaxPromo
  }"
>
  <img
    [src]="
      'https://storage.googleapis.com/dev-ps-asset/motor/d2c/loyalty-programme-tag-' +
      translate.currentLang +
      '.png'
    "
    alt=""
    *ngIf="class === 'motorMembershipLoyalty'"
    class="ribbon tag"
  />
  <img
    [src]="
      'https://storage.googleapis.com/dev-ps-asset/motor/d2c/special-promo-tag-tmim-' +
      translate.currentLang +
      '.png'
    "
    alt=""
    *ngIf="class === 'motorMembershipTMIM'"
    class="ribbon tag"
  />
  <img
    [src]="
      'https://storage.googleapis.com/dev-ps-asset/motor/d2c/exclusive-ps-tag-' +
      translate.currentLang +
      '.png'
    "
    alt=""
    *ngIf="class === 'motorMembership'"
    class="ribbon tag"
  />
  <img
    [src]="'/assets/icons/included_addon_' + translate.currentLang + '.png'"
    alt=""
    *ngIf="includedAddOn"
    class="ribbon"
  />
  <img
    [src]="'/assets/image/roadtax-promo-' + translate.currentLang + '.png'"
    alt=""
    *ngIf="isRoadtaxPromo && !isFreeRoadtax"
    class="ribbon roadtax-ribbon"
  />
  <img
    [src]="'/assets/image/roadtax-promo-full.png'"
    alt=""
    *ngIf="isRoadtaxPromo && isFreeRoadtax"
    class="ribbon roadtax-ribbon"
  />
  <div class="addon-info">
    <div class="addon-main" [ngClass]="isRoadtaxPromo ? 'pt-sm' : ''">
      <div>
        <img [src]="img" alt="" class="addon-img" />
      </div>
      <div class="content">
        <div *ngIf="showRHBRibbon" class="content__header">
          {{ "addOn.exclusiveRHB" | translate }}
        </div>
        <div *ngIf="showPSXTRATag" class="content__tag">
          <app-psxtra-tag></app-psxtra-tag>
        </div>
        <div
          *ngIf="class === 'roadTaxRenewalClass' && drivePlusSelected"
          class="content__tag"
        >
          <app-crown-tag
            icon="blue-crown-icon.svg"
            bgColor="blue"
            title="includedForMembers"
          ></app-crown-tag>
        </div>
        <div class="content__title">
          {{ title }}

          <ng-container *ngIf="tooltip && !includedAddOn">
            <!-- For mobile -->
            <ng-container *ngIf="screenSizeService.isMobile$ | async">
              <button
                mat-icon-button
                type="button"
                [matMenuTriggerFor]="Tooltip"
                #tooltipTrigger="matMenuTrigger"
                class="tooltip-button"
              >
                <img src="assets/icons/info-outline.png" alt="" />
              </button>
              <mat-menu
                #Tooltip="matMenu"
                [overlapTrigger]="false"
                class="tooltip-popover-d2c"
              >
                <span (mouseleave)="tooltipTrigger.closeMenu()">
                  {{ tooltip }}
                </span>
              </mat-menu>
            </ng-container>

            <!-- For desktop -->
            <ng-container *ngIf="!(screenSizeService.isMobile$ | async)">
              <button
                mat-icon-button
                #tooltip="matTooltip"
                [matTooltip]="processedTooltip"
                matTooltipPosition="below"
                class="tooltip-button"
              >
                <img src="assets/icons/info-outline.png" alt="" />
              </button>
            </ng-container>
          </ng-container>
        </div>
        <div class="content__label" *ngIf="label">
          {{ "plans.onlyOn" | translate }}
          <span class="bold">PolicyStreet</span>
        </div>
        <div class="content__desc">{{ desc }}</div>
        <ng-container *ngIf="price >= 0">
          <div class="content__info">
            <ng-container [ngSwitch]="class">
              <ng-container *ngSwitchCase="'motorMembership'">
                <div>
                  <div class="content__price--green">
                    <span>RM</span>{{ price | number : "1.2-2" }}
                    {{ "plans.specialPrice" | translate }}
                  </div>
                  <div class="content__price--black">NP: RM99.90</div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'motorMembershipTMIM'">
                <div>
                  <div class="content__price--green">
                    <span>RM</span>{{ price | number : "1.2-2" }}
                    {{ "plans.specialPriceTMIM" | translate }}
                  </div>
                  <div class="content__price--black">NP: RM99.90</div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'motorMembershipLoyalty'">
                <div>
                  <div class="content__price--green">
                    <span>RM</span>{{ price | number : "1.2-2" }}
                    {{ "plans.specialPriceLoyalCust" | translate }}
                  </div>
                  <div class="content__price--black">NP: RM99.90</div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'roadTaxRenewalClass'">
                <ng-container *ngIf="isRoadtaxPromo">
                  <div class="content__price">
                    <span class="strikethrough">
                      RM {{ price | number : "1.2-2" }}
                    </span>
                    <span class="roadtax-promo-price">
                      RM {{ roadtaxPromoPrice | number : "1.2-2" }}
                      <span *ngIf="!isFreeRoadtax">
                        {{ "common.only" | translate }}
                      </span>
                    </span>
                  </div>
                </ng-container>

                <ng-container *ngIf="!isRoadtaxPromo">
                  <ng-container *ngIf="drivePlusSelected">
                    <div class="content__price">
                      <span class="strikethrough">
                        RM {{ price | number : "1.2-2" }}
                      </span>
                      <span class="roadtax-promo-price">
                        RM {{ drivePlusRoadtaxPrice | number : "1.2-2" }}
                        <span *ngIf="!isFreeRoadtax">
                          {{ "common.only" | translate }}
                        </span>
                      </span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!drivePlusSelected">
                    <div class="content__price">
                      RM {{ price | number : "1.2-2" }}
                      <span
                        class="drivePlus-text"
                        [innerHTML]="'addOn.roadTaxDrivePlus' | translate"
                      ></span>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="content__price" *ngIf="selected">
                  RM 0.00 {{ "plans.included" | translate }}
                </div>
                <div class="content__price" *ngIf="!selected">
                  RM {{ price | number : "1.2-2" }}
                </div>
                <div
                  class="content__view"
                  *ngIf="showPSXTRATag"
                  (click)="onViewDetails()"
                >
                  {{ "addOn.viewDetails" | translate }}
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-content select="div[slot=normalWidth]"></ng-content>
      </div>
    </div>
    <div class="flex">
      <mat-checkbox
        [checked]="addOnSelected || selected"
        [disabled]="selected"
        (change)="toggleAddOn($event)"
        *ngIf="!includedAddOn"
      ></mat-checkbox>
    </div>
  </div>
  <ng-content select="div[slot=fullWidth]"></ng-content>
</mat-card>
